import ApiService from '@common/lib/api/api.service';
import { stringify } from 'query-string';

export const add = params => {
  return ApiService.multiPost(`Review`, params);
};

export const getById = params => {
  return ApiService.query(`Review/${params.id}`);
};

export const remove = params => {
  return ApiService.delete(`Review/${params.id}`);
};

export const report = params => {
  return ApiService.post(`Review/report`, params);
};

export const reportUser = params => {
  return ApiService.post(`Review/user/report/${params.userId}`);
};

export const search = params => {
  return ApiService.query(`Review/search?${stringify(params)}`);
};

export const modifyVisible = params => {
  let id;
  for (let p of params) {
    let name = p[0];
    let value = p[1];
    if (name == 'id') {
      id = value;
    }
  }

  return ApiService.put(`Review/${id}/visible`, params);
};

export const getReportList = params => {
  return ApiService.query(`Review/report/search?${stringify(params)}`);
};

export const getAllReportList = params => {
  return ApiService.query(`Review/report/search/all?${stringify(params)}`);
};

export const modifyReportVisible = params => {
  return ApiService.put(`Review/report/visible`, params);
};
export const check = params => {
  return ApiService.query(`Review/check?${stringify(params)}`);
};
export const getScore = params => {
  return ApiService.query(`Review/review/score/${params}`);
};
export const choiceCount = params => {
  return ApiService.post(`Review/review/choice/count`, params);
};
// 후기 작성 팝업
export const reviewPopup = params => {
  return ApiService.query(`Review/review/popup?${stringify(params)}`);
};
// 후기 작성 팝업 확인 처리
export const reviewPopupComfirm = params => {
  return ApiService.put(`Review/review/popup?${stringify(params)}`);
};

// 메인페이지 리뷰
export const getReviews = params => {
  return ApiService.query(`Review/reviews?${stringify(params)}`);
};
